import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { EventBusClickService } from "@bca-core/services/event-bus.service";
import { IProduct } from "@bca-shared/models/product";

@Component({
  selector: "bca-receipt-item",
  templateUrl: "receipt-item.component.html",
  styleUrls: ["receipt-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptItemComponent {
  @Input()
  product: IProduct;
  @Input()
  disableEdit: boolean;
  @Input()
  isSelectedProduct: boolean;

  @Output()
  remove = new EventEmitter<IProduct>();
  @Output()
  edit = new EventEmitter<IProduct>();

  @Input()
  totalProductCount: number;
  @Input()
  currentProductNumber: number;
  @Input()
  enableSelectedBox: boolean;

  constructor(private _eventBus: EventBusClickService) {}

  editProduct(product: IProduct): void {
    this._eventBus.clickClose(false);
    this.edit.emit(product);
  }

  removeProduct(product: IProduct): void {
    this.remove.emit(product);
  }
}
